import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import billingService from '../../services/billingService';
import printerService from '../../services/printerService';


const Clientes = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [previewCustomer, setPreviewCustomer] = useState(null);
    // CRUD: cliente en edición (null = nuevo), detalle abierto y filtro de inactivos
    const [editingCustomer, setEditingCustomer] = useState(null);
    const [detailCustomer, setDetailCustomer] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [showInactive, setShowInactive] = useState(false);
    const [voucherConfig, setVoucherConfig] = useState({
        business_name: 'TIONEL',
        ruc: '0401788617001',
        establishment_address: 'Av. Principal 123, Quito - Ecuador',
        obligation_contable: 'NO',
        contribuyente_regimen: 'RIMPE - NEGOCIO POPULAR',
        footer_message: '¡Gracias por su preferencia!\nEste documento es una representación impresa de un Comprobante Electrónico (RIDE).'
    });

    const emptyCustomerForm = {
        email: '',
        password: 'Password123!',
        password_confirmation: 'Password123!',
        cedula: '',
        first_name: '',
        last_name: '',
        phone: '',
        address: '',
        city: '',
        is_active: true
    };
    const [newCustomer, setNewCustomer] = useState(emptyCustomerForm);


    useEffect(() => {
        loadVoucherConfig();
    }, []);

    useEffect(() => {
        fetchCustomers(searchTerm);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showInactive]);

    const loadVoucherConfig = async () => {
        try {
            const data = await billingService.getConfig();
            if (data) {
                setVoucherConfig({
                    business_name: data.business_name || 'TIONEL',
                    ruc: data.ruc || '0401788617001',
                    establishment_address: data.establishment_address || 'Av. Principal 123, Quito - Ecuador',
                    obligation_contable: data.obligation_contable || 'NO',
                    contribuyente_regimen: data.contribuyente_regimen || 'RIMPE - NEGOCIO POPULAR',
                    footer_message: data.footer_message || '¡Gracias por su preferencia!\nEste documento es una representación impresa de un Comprobante Electrónico (RIDE).'
                });
            }
        } catch (e) {
            console.error('Error cargando configuración de ticket:', e);
        }
    };


    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key !== 'Escape') return;
            if (showModal) closeModal();
            else if (detailCustomer) setDetailCustomer(null);
        };

        if (showModal || detailCustomer) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [showModal, detailCustomer]);

    const fetchCustomers = async (search = '') => {
        setLoading(true);
        setError('');
        try {
            const params = search ? { search } : {};
            if (!showInactive) params.active = 'true';
            const response = await api.get('/api/customers/admin/list/', {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
                params
            });
            setCustomers(response.data.data.customers || []);
        } catch (err) {
            console.error('Error fetching customers:', err);
            setError('Error al cargar clientes: ' + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        fetchCustomers(searchTerm);
    };

    const handleCreateCustomer = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        // Cédula vacía = sin cédula (se envía null para no chocar con otros clientes sin cédula)
        const cedula = (newCustomer.cedula || '').trim() || null;
        try {
            if (editingCustomer) {
                const { email, phone, first_name, last_name, address, city, is_active } = newCustomer;
                await api.patch(`/api/customers/admin/${editingCustomer.id}/`,
                    { email, phone, cedula, first_name, last_name, address, city, is_active },
                    { baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE });
                showNotification('Cliente actualizado', 'success');
            } else {
                const { is_active, ...payload } = newCustomer;
                await api.post('/api/customers/register/', { ...payload, cedula }, {
                    baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
                });
                showNotification('Cliente creado exitosamente', 'success');
            }
            closeModal();
            fetchCustomers(searchTerm);
        } catch (err) {
            console.error('Error saving customer:', err);
            const errorData = err.response?.data;
            let errorMessage = editingCustomer ? 'Error al actualizar cliente' : 'Error al crear cliente';

            if (errorData?.errors) {
                errorMessage += ':\n' + Object.entries(errorData.errors)
                    .map(([key, val]) => `- ${key}: ${val}`)
                    .join('\n');
            } else if (errorData?.message) {
                errorMessage += ': ' + errorData.message;
            } else {
                errorMessage += ': ' + err.message;
            }

            alert(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCustomer(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingCustomer(null);
        setNewCustomer(emptyCustomerForm);
    };

    const openCreateModal = () => {
        setEditingCustomer(null);
        setNewCustomer(emptyCustomerForm);
        setShowModal(true);
    };

    const openEditModal = (customer) => {
        setDetailCustomer(null);
        setEditingCustomer(customer);
        setNewCustomer({
            ...emptyCustomerForm,
            email: customer.email || '',
            cedula: customer.cedula || '',
            first_name: customer.first_name || '',
            last_name: customer.last_name || '',
            phone: customer.phone || '',
            address: customer.address || '',
            city: customer.city || '',
            is_active: customer.is_active !== false
        });
        setShowModal(true);
    };

    const openDetail = async (customer) => {
        setDetailCustomer(customer);
        setDetailLoading(true);
        try {
            const res = await api.get(`/api/customers/admin/${customer.id}/`, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            setDetailCustomer(res.data?.data || customer);
        } catch (err) {
            console.error('Error cargando detalle del cliente:', err);
        } finally {
            setDetailLoading(false);
        }
    };

    const handleDeleteCustomer = async (customer) => {
        const name = `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || customer.email;
        if (!window.confirm(`¿Eliminar al cliente "${name}"?\n\nSi tiene órdenes registradas no se borra: se desactiva para conservar el historial y las facturas.`)) return;
        try {
            const res = await api.delete(`/api/customers/admin/${customer.id}/`, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            setDetailCustomer(null);
            showNotification(res.data?.message || 'Cliente eliminado', 'success');
            fetchCustomers(searchTerm);
        } catch (err) {
            alert('Error al eliminar cliente: ' + (err.response?.data?.message || err.message));
        }
    };

    const getCedula = (customer) => customer?.cedula || '9999999999999';

    const showNotification = (message, type) => {
        // Simple notification - you can replace with a toast library
        alert(message);
    };

    const formInputStyle = {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        outline: 'none',
        fontSize: '14px',
        boxSizing: 'border-box'
    };

    const getCustomerTypeColor = (type) => {
        const colors = {
            'regular': 'bg-blue-100 text-blue-700 border-blue-200',
            'premium': 'bg-purple-100 text-purple-700 border-purple-200',
            'vip': 'bg-amber-100 text-amber-700 border-amber-200'
        };
        return colors[type?.toLowerCase()] || 'bg-gray-100 text-gray-700 border-gray-200';
    };

    if (loading && customers.length === 0) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'var(--sidebar-bg)' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        display: 'inline-block',
                        width: '48px',
                        height: '48px',
                        border: '4px solid #e5e7eb',
                        borderTopColor: '#2563eb',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                    <p style={{ marginTop: '16px', color: '#4b5563', fontWeight: '500' }}>Cargando clientes...</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, var(--sidebar-bg), var(--sidebar-bg))', padding: '24px' }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                {/* Header */}
                <div style={{ marginBottom: '32px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px' }}>
                    <div>
                        <h1 style={{ fontSize: '30px', fontWeight: 'bold', color: '#1f2937', marginBottom: '8px' }}>Gestión de Clientes</h1>
                        <p style={{ color: '#6b7280' }}>Administra la base de datos de clientes del restaurante</p>
                    </div>
                    <button
                        onClick={openCreateModal}
                        style={{
                            backgroundColor: '#2563eb',
                            color: 'white',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            border: 'none',
                            fontWeight: '500',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.2s',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#1d4ed8';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#2563eb';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                        }}
                    >
                        <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Nuevo Cliente
                    </button>
                </div>

                {/* Search Bar */}
                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', padding: '16px', marginBottom: '24px' }}>
                    <form onSubmit={handleSearch} style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div style={{ flex: 1, position: 'relative' }}>
                            <svg
                                style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '20px',
                                    height: '20px',
                                    color: '#9ca3af'
                                }}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Buscar por nombre, cédula, email o teléfono..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px 16px 10px 44px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    fontSize: '14px',
                                    transition: 'all 0.2s'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = 'var(--primary-color)';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(96, 56, 51, 0.15)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#d1d5db';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                backgroundColor: '#6b7280',
                                color: 'white',
                                padding: '10px 20px',
                                borderRadius: '8px',
                                border: 'none',
                                fontWeight: '500',
                                cursor: 'pointer',
                                fontSize: '14px',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#4b5563'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6b7280'}
                        >
                            Buscar
                        </button>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#4b5563', whiteSpace: 'nowrap', cursor: 'pointer' }}>
                            <input type="checkbox" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)} />
                            Ver inactivos
                        </label>
                    </form>
                </div>

                {/* Error Message */}
                {error && (
                    <div style={{
                        backgroundColor: '#fef2f2',
                        border: '1px solid #fecaca',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        marginBottom: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <svg style={{ width: '20px', height: '20px', color: '#ef4444' }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                        <span style={{ color: '#991b1b', fontSize: '14px' }}>{error}</span>
                    </div>
                )}

                {/* Customers Table */}
                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ background: 'linear-gradient(to right, var(--sidebar-bg), var(--sidebar-bg))', borderBottom: '1px solid #e5e7eb' }}>
                                <tr>
                                    <th style={{ padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Cliente
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Cédula / RUC
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Contacto
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Ciudad
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Tipo
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Registro
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'center', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Voucher SRI
                                    </th>
                                    <th style={{ padding: '16px 24px', textAlign: 'center', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Acciones
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {customers.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" style={{ padding: '48px 24px', textAlign: 'center' }}>

                                            <svg
                                                style={{ width: '48px', height: '48px', margin: '0 auto 16px', color: '#d1d5db' }}
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                            </svg>
                                            <p style={{ color: '#6b7280', fontWeight: '500', fontSize: '16px', margin: 0 }}>
                                                {searchTerm ? 'No se encontraron clientes' : 'No hay clientes registrados'}
                                            </p>
                                            {searchTerm && (
                                                <p style={{ color: '#9ca3af', fontSize: '14px', marginTop: '8px' }}>
                                                    Intenta con otros términos de búsqueda
                                                </p>
                                            )}
                                        </td>
                                    </tr>
                                ) : (
                                    customers.map(customer => (
                                        <tr
                                            key={customer.id}
                                            style={{
                                                borderBottom: '1px solid #e5e7eb',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--sidebar-bg)'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <td style={{ padding: '16px 24px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <div style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#eff6ff',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontWeight: '600',
                                                        color: '#2563eb',
                                                        fontSize: '14px'
                                                    }}>
                                                        {customer.first_name?.charAt(0)}{customer.last_name?.charAt(0)}
                                                    </div>
                                                    <div>
                                                        <p style={{ margin: 0, fontWeight: '600', color: '#1f2937' }}>
                                                            {customer.first_name} {customer.last_name}
                                                            {customer.is_active === false && (
                                                                <span style={{ marginLeft: '8px', padding: '2px 8px', borderRadius: '9999px', fontSize: '11px', fontWeight: '600', backgroundColor: '#fee2e2', color: '#b91c1c' }}>
                                                                    Inactivo
                                                                </span>
                                                            )}
                                                        </p>
                                                        <p style={{ margin: '2px 0 0 0', fontSize: '13px', color: '#6b7280' }}>
                                                            {customer.email}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                <span style={{ fontFamily: 'monospace', fontWeight: '600', color: '#1f2937', fontSize: '13px' }}>
                                                    {getCedula(customer)}
                                                </span>
                                            </td>
                                            <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <svg style={{ width: '16px', height: '16px', color: '#6b7280' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                    </svg>
                                                    <span style={{ color: '#374151', fontSize: '14px' }}>
                                                        {customer.phone || 'Sin teléfono'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                <span style={{ color: '#4b5563', fontSize: '14px' }}>
                                                    {customer.city || '-'}
                                                </span>
                                            </td>
                                            <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                <span
                                                    className={getCustomerTypeColor(customer.customer_type)}
                                                    style={{
                                                        padding: '4px 12px',
                                                        borderRadius: '9999px',
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        border: '1px solid',
                                                        display: 'inline-block'
                                                    }}
                                                >
                                                    {customer.customer_type}
                                                </span>
                                            </td>
                                            <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                                <span style={{ fontSize: '14px', color: '#4b5563' }}>
                                                    {new Date(customer.created_at).toLocaleDateString('es-ES', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    })}
                                                </span>
                                            </td>
                                            <td style={{ padding: '16px 24px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => setPreviewCustomer(customer)}
                                                    style={{
                                                        padding: '6px 12px',
                                                        backgroundColor: '#f1f5f9',
                                                        color: '#0f172a',
                                                        border: '1px solid #cbd5e1',
                                                        borderRadius: '6px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        transition: 'all 0.2s'
                                                    }}
                                                >
                                                    <i className="bi bi-receipt"></i> Ver Ticket
                                                </button>
                                            </td>
                                            <td style={{ padding: '16px 24px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                <div style={{ display: 'inline-flex', gap: '6px' }}>
                                                    {[
                                                        { icon: 'bi-eye', title: 'Ver detalles', onClick: () => openDetail(customer), color: '#0f172a', bg: '#f1f5f9', border: '#cbd5e1' },
                                                        { icon: 'bi-pencil-square', title: 'Editar', onClick: () => openEditModal(customer), color: '#603833', bg: '#f5ede4', border: '#e5d3c0' },
                                                        { icon: 'bi-trash', title: 'Eliminar', onClick: () => handleDeleteCustomer(customer), color: '#b91c1c', bg: '#fef2f2', border: '#fecaca' }
                                                    ].map(btn => (
                                                        <button key={btn.icon} type="button" title={btn.title} aria-label={btn.title} onClick={btn.onClick}
                                                            style={{ width: '36px', height: '36px', borderRadius: '8px', border: `1px solid ${btn.border}`, backgroundColor: btn.bg, color: btn.color, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px' }}>
                                                            <i className={`bi ${btn.icon}`}></i>
                                                        </button>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/* Footer Stats */}
                {customers.length > 0 && (
                    <div style={{ marginTop: '24px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', padding: '16px' }}>
                        <p style={{ fontSize: '14px', color: '#4b5563', margin: 0 }}>
                            Mostrando <span style={{ fontWeight: '600', color: '#1f2937' }}>{customers.length}</span> cliente{customers.length !== 1 ? 's' : ''}
                        </p>
                    </div>
                )}
            </div>

            {/* Create Customer Modal */}
            {showModal && (
                <div
                    onClick={closeModal}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '20px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '600px',
                            width: '100%',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
                                    {editingCustomer ? 'Editar Cliente' : 'Nuevo Cliente'}
                                </h2>
                                <p style={{ color: '#6b7280', fontSize: '14px', marginTop: '4px', marginBottom: 0 }}>
                                    {editingCustomer ? 'Corrige los datos del cliente' : 'Completa la información del cliente'}
                                </p>
                            </div>
                            <button
                                onClick={closeModal}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#6b7280',
                                    padding: '4px 8px',
                                    lineHeight: 1
                                }}
                                aria-label="Cerrar modal"
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body */}
                        <form onSubmit={handleCreateCustomer}>
                            <div style={{ padding: '24px' }}>
                                {/* Cédula / RUC */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Cédula / RUC
                                    </label>
                                    <input
                                        type="text"
                                        name="cedula"
                                        inputMode="numeric"
                                        value={newCustomer.cedula}
                                        onChange={handleInputChange}
                                        placeholder="10 dígitos (cédula) o 13 (RUC). Vacío = Consumidor Final"
                                        style={formInputStyle}
                                    />
                                </div>

                                {/* Email */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Email *
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={newCustomer.email}
                                        onChange={handleInputChange}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            outline: 'none',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--primary-color)';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(96, 56, 51, 0.15)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>

                                {/* Nombre y Apellido */}
                                <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Nombre *
                                        </label>
                                        <input
                                            type="text"
                                            name="first_name"
                                            value={newCustomer.first_name}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                outline: 'none',
                                                fontSize: '14px',
                                                transition: 'all 0.2s'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = 'var(--primary-color)';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(96, 56, 51, 0.15)';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = '#d1d5db';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Apellido *
                                        </label>
                                        <input
                                            type="text"
                                            name="last_name"
                                            value={newCustomer.last_name}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                outline: 'none',
                                                fontSize: '14px',
                                                transition: 'all 0.2s'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = 'var(--primary-color)';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(96, 56, 51, 0.15)';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = '#d1d5db';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Teléfono */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Teléfono *
                                    </label>
                                    <input
                                        type="text"
                                        name="phone"
                                        inputMode="tel"
                                        value={newCustomer.phone}
                                        onChange={handleInputChange}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            outline: 'none',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--primary-color)';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(96, 56, 51, 0.15)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>

                                {/* Ciudad */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Ciudad
                                    </label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={newCustomer.city}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            outline: 'none',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--primary-color)';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(96, 56, 51, 0.15)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>

                                {/* Dirección */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Dirección
                                    </label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={newCustomer.address}
                                        onChange={handleInputChange}
                                        style={formInputStyle}
                                    />
                                </div>

                                {editingCustomer && (
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontSize: '14px', color: '#374151', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={newCustomer.is_active}
                                            onChange={(e) => setNewCustomer(prev => ({ ...prev, is_active: e.target.checked }))}
                                        />
                                        Cliente activo (aparece en el punto de venta y al cobrar)
                                    </label>
                                )}

                                {/* Info Note */}
                                {!editingCustomer && (
                                <div style={{
                                    backgroundColor: '#eff6ff',
                                    border: '1px solid #bfdbfe',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    gap: '8px',
                                    marginBottom: '20px'
                                }}>
                                    <svg style={{ width: '20px', height: '20px', color: '#2563eb', flexShrink: 0, marginTop: '2px' }} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                    <p style={{ margin: 0, fontSize: '13px', color: '#1e40af', lineHeight: '1.5' }}>
                                        Se asignará automáticamente la contraseña predeterminada: <strong>Password123!</strong>
                                    </p>
                                </div>
                                )}
                            </div>

                            {/* Modal Footer */}
                            <div style={{
                                padding: '16px 24px',
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                backgroundColor: 'var(--sidebar-bg)'
                            }}>
                                <button
                                    type="button"
                                    onClick={closeModal}
                                    disabled={submitting}
                                    style={{
                                        backgroundColor: 'white',
                                        color: '#374151',
                                        padding: '10px 20px',
                                        borderRadius: '8px',
                                        border: '1px solid #d1d5db',
                                        fontWeight: '500',
                                        cursor: submitting ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        transition: 'all 0.2s',
                                        opacity: submitting ? 0.5 : 1
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!submitting) {
                                            e.currentTarget.style.backgroundColor = 'var(--sidebar-bg)';
                                            e.currentTarget.style.borderColor = '#9ca3af';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'white';
                                        e.currentTarget.style.borderColor = '#d1d5db';
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    disabled={submitting}
                                    style={{
                                        backgroundColor: submitting ? '#93c5fd' : '#2563eb',
                                        color: 'white',
                                        padding: '10px 24px',
                                        borderRadius: '8px',
                                        border: 'none',
                                        fontWeight: '500',
                                        cursor: submitting ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        transition: 'all 0.2s',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!submitting) {
                                            e.currentTarget.style.backgroundColor = '#1d4ed8';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!submitting) {
                                            e.currentTarget.style.backgroundColor = '#2563eb';
                                        }
                                    }}
                                >
                                    {submitting ? (
                                        <>
                                            <div style={{
                                                width: '16px',
                                                height: '16px',
                                                border: '2px solid white',
                                                borderTopColor: 'transparent',
                                                borderRadius: '50%',
                                                animation: 'spin 0.6s linear infinite'
                                            }}></div>
                                            Guardando...
                                        </>
                                    ) : (
                                        <>
                                            <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                            {editingCustomer ? 'Guardar Cambios' : 'Guardar Cliente'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
            {/* Modal de Detalles del Cliente */}
            {detailCustomer && (() => {
                const c = detailCustomer;
                const fmtDate = (d) => d ? new Date(d).toLocaleDateString('es-EC', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';
                const rows = [
                    ['Cédula / RUC', getCedula(c)],
                    ['Email', c.email],
                    ['Teléfono', c.phone],
                    ['Ciudad', c.city],
                    ['Dirección', c.address],
                    ['Tipo', c.customer_type],
                    ['Estado', c.is_active === false ? 'Inactivo' : 'Activo'],
                    ['Registrado', fmtDate(c.created_at)],
                    ['Última actualización', fmtDate(c.updated_at)]
                ];
                const stats = [
                    ['Órdenes', c.total_orders ?? 0],
                    ['Total gastado', `$${(parseFloat(c.total_spent) || 0).toFixed(2)}`],
                    ['Ticket promedio', `$${(parseFloat(c.average_order_value) || 0).toFixed(2)}`],
                    ['Última orden', fmtDate(c.last_order_date)],
                    ['Puntos', c.loyalty_points ?? 0]
                ];
                return (
                    <div onClick={() => setDetailCustomer(null)}
                        style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
                        <div onClick={(e) => e.stopPropagation()}
                            style={{ backgroundColor: 'white', borderRadius: '16px', maxWidth: '560px', width: '100%', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', flexShrink: 0 }}>
                                    {c.first_name?.charAt(0)}{c.last_name?.charAt(0)}
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>{c.first_name} {c.last_name}</h2>
                                    <p style={{ color: '#6b7280', fontSize: '13px', margin: '2px 0 0 0' }}>{detailLoading ? 'Cargando...' : 'Detalles del cliente'}</p>
                                </div>
                                <button onClick={() => setDetailCustomer(null)} aria-label="Cerrar"
                                    style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6b7280', padding: '4px 8px', lineHeight: 1 }}>×</button>
                            </div>

                            <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '8px' }}>
                                    {stats.map(([label, value]) => (
                                        <div key={label} style={{ padding: '10px 12px', borderRadius: '10px', backgroundColor: 'var(--sidebar-bg)', border: '1px solid #e5e7eb' }}>
                                            <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '600', textTransform: 'uppercase' }}>{label}</div>
                                            <div style={{ fontSize: '16px', color: '#1f2937', fontWeight: '700', marginTop: '2px' }}>{value}</div>
                                        </div>
                                    ))}
                                </div>
                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '10px', overflow: 'hidden' }}>
                                    {rows.map(([label, value], i) => (
                                        <div key={label} style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', padding: '10px 14px', fontSize: '14px', backgroundColor: i % 2 ? '#ffffff' : '#f9fafb' }}>
                                            <span style={{ color: '#6b7280' }}>{label}</span>
                                            <span style={{ color: '#1f2937', fontWeight: '600', textAlign: 'right', wordBreak: 'break-word' }}>{value || '-'}</span>
                                        </div>
                                    ))}
                                </div>
                                {Array.isArray(c.notes) && c.notes.length > 0 && (
                                    <div>
                                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#374151', marginBottom: '6px' }}>Notas</div>
                                        {c.notes.map(n => (
                                            <p key={n.id} style={{ margin: '0 0 6px 0', padding: '8px 12px', borderRadius: '8px', backgroundColor: '#fef3c7', color: '#92400e', fontSize: '13px' }}>{n.content}</p>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div style={{ padding: '14px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap', backgroundColor: 'var(--sidebar-bg)' }}>
                                <button type="button" onClick={() => handleDeleteCustomer(c)}
                                    style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid #fecaca', backgroundColor: '#fef2f2', color: '#b91c1c', fontWeight: '600', cursor: 'pointer', marginRight: 'auto' }}>
                                    <i className="bi bi-trash"></i> Eliminar
                                </button>
                                <button type="button" onClick={() => setDetailCustomer(null)}
                                    style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid #d1d5db', backgroundColor: 'white', color: '#374151', fontWeight: '500', cursor: 'pointer' }}>
                                    Cerrar
                                </button>
                                <button type="button" onClick={() => openEditModal(c)}
                                    style={{ padding: '10px 16px', borderRadius: '8px', border: 'none', backgroundColor: '#603833', color: 'white', fontWeight: '600', cursor: 'pointer' }}>
                                    <i className="bi bi-pencil-square"></i> Editar
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Modal de Vista Previa del Voucher SRI para el Cliente */}
            {previewCustomer && (
                <div
                    onClick={() => setPreviewCustomer(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1050,
                        padding: '20px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '400px',
                            width: '100%',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            padding: '20px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', borderBottom: '1px solid #e5e7eb', paddingBottom: '10px' }}>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#1f2937' }}>
                                <i className="bi bi-receipt"></i> Voucher / Ticket SRI
                            </h3>
                            <button
                                onClick={() => setPreviewCustomer(null)}
                                style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#6b7280' }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Ticket Renderizado */}
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '16px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '4px',
                            fontFamily: '"Courier New", Courier, monospace',
                            fontSize: '11px',
                            color: '#000',
                            lineHeight: 1.3
                        }}>
                            <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '8px', marginBottom: '8px' }}>
                                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{voucherConfig.business_name}</div>
                                <div>RUC: {voucherConfig.ruc}</div>
                                <div>{voucherConfig.establishment_address}</div>
                                {voucherConfig.company_phone && <div>Telf: {voucherConfig.company_phone}</div>}
                                <div style={{ marginTop: '2px', fontSize: '9px' }}>Obligado a llevar contabilidad: {voucherConfig.obligation_contable}</div>
                                {voucherConfig.contribuyente_regimen && <div style={{ fontSize: '9px' }}>CONTRIBUYENTE {voucherConfig.contribuyente_regimen}</div>}
                                {voucherConfig.artisan_qualification && <div style={{ fontSize: '9px' }}>CALIFICACIÓN ARTESANAL NO. {voucherConfig.artisan_qualification}</div>}
                            </div>

                            <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                <div style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '11px' }}>FACTURA ELECTRÓNICA</div>
                                <div>No: 001-001-000000129</div>
                                <div>Fecha: {new Date().toLocaleDateString('es-EC')} {new Date().toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' })}</div>
                                <div>Estado: <span style={{ fontWeight: 'bold' }}>AUTORIZADO</span></div>
                                <div style={{ marginTop: '4px' }}><strong>Cliente:</strong> {previewCustomer.first_name} {previewCustomer.last_name}</div>
                                <div><strong>RUC/CI:</strong> {getCedula(previewCustomer)}</div>
                                {previewCustomer.address && <div><strong>Dir:</strong> {previewCustomer.address}</div>}
                                {previewCustomer.email && <div><strong>Email:</strong> {previewCustomer.email}</div>}
                            </div>

                            <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '2px', marginBottom: '3px' }}>
                                    <span>Cant. Descripción</span>
                                    <span style={{ textAlign: 'right' }}>P.Unit</span>
                                    <span style={{ textAlign: 'right' }}>Total</span>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', margin: '2px 0' }}>
                                    <span>1x Consumo General</span>
                                    <span style={{ textAlign: 'right' }}>$8.70</span>
                                    <span style={{ textAlign: 'right' }}>$8.70</span>
                                </div>
                            </div>

                            <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>SUBTOTAL:</span>
                                    <span>$8.70</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>IVA:</span>
                                    <span>$1.30</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: 'bold', marginTop: '3px', borderTop: '1px solid #000', paddingTop: '3px' }}>
                                    <span>TOTAL A PAGAR:</span>
                                    <span>$10.00</span>
                                </div>
                            </div>

                            <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '8px', marginBottom: '8px' }}>
                                <div style={{ fontSize: '9px', fontWeight: 'bold', marginBottom: '2px' }}>CLAVE DE ACCESO / AUTORIZACIÓN:</div>
                                <div style={{ fontSize: '8.5px', wordBreak: 'break-all' }}>
                                    2408202601040178861700110010010000001291234567818
                                </div>
                                <div style={{
                                    height: '30px',
                                    background: 'repeating-linear-gradient(90deg, #000, #000 2px, #fff 2px, #fff 4px, #000 4px, #000 7px, #fff 7px, #fff 8px)',
                                    margin: '6px 8px 3px'
                                }}></div>
                            </div>

                            <div style={{ textAlign: 'center', fontSize: '9px', whiteSpace: 'pre-line', marginBottom: '6px' }}>
                                {voucherConfig.footer_message}
                            </div>

                            {voucherConfig.developer_credits && (
                                <div style={{ textAlign: 'center', fontSize: '8.5px', color: '#555', borderTop: '1px dotted #888', paddingTop: '4px' }}>
                                    {voucherConfig.developer_credits}
                                </div>
                            )}
                        </div>

                        <div style={{ marginTop: '16px', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button
                                type="button"
                                onClick={async () => {
                                    try {
                                        const dateStr = new Date().toLocaleDateString('es-EC');
                                        const timeStr = new Date().toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' });
                                        const dni = getCedula(previewCustomer);
                                        
                                        const ticketContent = 
`================================
${voucherConfig.business_name}
RUC: ${voucherConfig.ruc}
${voucherConfig.establishment_address}
${voucherConfig.company_phone ? `Telf: ${voucherConfig.company_phone}\n` : ''}Obligado a contabilidad: ${voucherConfig.obligation_contable}
${voucherConfig.contribuyente_regimen ? `CONTRIBUYENTE ${voucherConfig.contribuyente_regimen}\n` : ''}${voucherConfig.artisan_qualification ? `CALIFICACION ARTESANAL NO. ${voucherConfig.artisan_qualification}\n` : ''}================================
FACTURA ELECTRONICA
No: 001-001-000000129
Fecha: ${dateStr} ${timeStr}
Estado: AUTORIZADO
--------------------------------
Cliente: ${previewCustomer.first_name} ${previewCustomer.last_name}
RUC/CI: ${dni}
${previewCustomer.address ? `Dir: ${previewCustomer.address}\n` : ''}${previewCustomer.email ? `Email: ${previewCustomer.email}\n` : ''}--------------------------------
Cant. Descripcion        Total
1x Consumo General      $8.70
--------------------------------
SUBTOTAL:               $8.70
IVA:                    $1.30
--------------------------------
TOTAL A PAGAR:         $10.00
--------------------------------
Forma de Pago:
EFECTIVO (SIN SISTEMA FINANCIERO): $10.00
================================
CLAVE DE ACCESO:
2408202601040178861700110010010000001291234567818
================================
${voucherConfig.footer_message}
${voucherConfig.developer_credits ? `\n--------------------------------\n${voucherConfig.developer_credits}` : ''}
`;
                                        await printerService.printCustomTicket(ticketContent, 'receipt');
                                        if (!/android/i.test(navigator.userAgent)) alert('Voucher enviado a la impresora.');
                                    } catch (err) {
                                        window.print();
                                    }
                                }}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: 'var(--primary-color, #4a7c59)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}
                            >
                                <i className="bi bi-printer-fill"></i> Imprimir en Impresora POS
                            </button>
                        </div>


                    </div>
                </div>
            )}
        </div>
    );
};

export default Clientes;